// can later add in pulling data from DB or from S3 (DB is probably better)
import trackConfiguration from '../../config/trackConfiguration.js';

export const getSegmentDefinition = (configId) => {
  // Find the configuration by configId across all tracks and configurations
  for (const track of trackConfiguration.tracks) {
    for (const config of track.configurations) {
      if (config.configId === configId) {
        return config.segments;
      }
    }
  }
  
  console.log('unrecognized track configuration:', configId);
  return null;
};

// Helper function to get all available track configurations
export const getAvailableTrackConfigs = () => {
  const configs = [];
  for (const track of trackConfiguration.tracks) {
    for (const config of track.configurations) {
      configs.push({
        configId: config.configId,
        trackName: track.trackName,
        configName: config.name,
        length: config.length,
        direction: config.direction
      });
    }
  }
  return configs;
};

// Helper function to get full track configuration
export const getTrackConfiguration = (configId) => {
  for (const track of trackConfiguration.tracks) {
    for (const config of track.configurations) {
      if (config.configId === configId) {
        return {
          track: track.trackName,
          trackId: track.trackId,
          configuration: config
        };
      }
    }
  }
  return null;
};

// Helper function to get all tracks
export const getAllTracks = () => {
  return trackConfiguration.tracks;
};
